export default __webpack_public_path__ + "static/media/pac_sat.5c5b223e.svg";